module.exports = __webpack_public_path__ + "img/serachIcon.f4551578.svg";